var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_84_180",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_84_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.02532 12.3084C3.7672 12.3084 3.54704 12.2166 3.36484 12.033C3.18265 11.8493 3.09155 11.6285 3.09155 11.3706V6.12964C3.09155 5.8717 3.18338 5.65091 3.36703 5.46726C3.55068 5.28361 3.77148 5.19178 4.02941 5.19178H4.49155V3.79178C4.49155 3.09567 4.73592 2.50359 5.22466 2.01553C5.7133 1.52748 6.30616 1.28345 7.00324 1.28345C7.70023 1.28345 8.29197 1.52748 8.77847 2.01553C9.26497 2.50359 9.50822 3.09567 9.50822 3.79178V5.19178H9.97037C10.2283 5.19178 10.4491 5.28361 10.6327 5.46726C10.8164 5.65091 10.9082 5.8717 10.9082 6.12964V11.3706C10.9082 11.6285 10.8163 11.8493 10.6326 12.033C10.4487 12.2166 10.2278 12.3084 9.96978 12.3084H4.02532ZM7.00295 9.65428C7.25514 9.65428 7.4684 9.5661 7.64272 9.38974C7.81694 9.21348 7.90405 8.99925 7.90405 8.74705C7.90405 8.49486 7.81587 8.2816 7.63951 8.10728C7.46325 7.93306 7.24902 7.84595 6.99682 7.84595C6.74463 7.84595 6.53137 7.93413 6.35705 8.11049C6.18283 8.28675 6.09572 8.50098 6.09572 8.75318C6.09572 9.00537 6.1839 9.21863 6.36026 9.39295C6.53653 9.56717 6.75075 9.65428 7.00295 9.65428ZM5.24989 5.19178H8.74989V3.79178C8.74989 3.30567 8.57975 2.89248 8.23947 2.5522C7.89919 2.21192 7.486 2.04178 6.99989 2.04178C6.51378 2.04178 6.10058 2.21192 5.7603 2.5522C5.42002 2.89248 5.24989 3.30567 5.24989 3.79178V5.19178Z",
    fill: "#9C9C9C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.73a231685e2010f3554f5b0888232537.svg";
export { ForwardRef as ReactComponent };